import Airport from '../airport';
import FromAirport from './fromAirport';
import ToAirport from './toAirport';

export default class FlightSearchInput {
  refId: number;
  fromAirport: Airport;
  toAirport: Airport;
  fromAirportId: string;
  toAirportId: string;
  clientDepartureDate: string;
  clientArrivalDate: string;
  adultCount: number;
  childCount: number;
  infantCount: number;
  flightSearchType: number;
  flightType: string;
  currencyId: string;
  departureDate: string;
  arrivalDate: string;
}
